/* eslint-disable */
import 'jquery-validate';
import 'jquery-timepicker';
import 'jquery-fancybox';
import 'jquery-mailcheck';
import 'jquery-select2';
import 'jquery-fullcalendar';
import 'bootstrap';
import 'bootstrap-datepicker';
import 'bootstrap-treeview';
import 'bootstrap-colorpalette';
import 'moment-timezone';
import 'jquery-ui';
import 'filesaver';
import 'mutation-events';
/* eslint-enable */
import 'regenerator-runtime/runtime';
import '@sendible/localization/dictionary';
import '../react/scss/index.scss';
import './config.js';
import './libs/sendible/sendible.js';
import './libs/sendible/utils.js';
import './global.js';
import './libs/sendible/validator.js';
import './libs/sendible/cache.js';
import './permissionsManager.js';
import './views/common/tinymce-module.js';
import { lookup } from '@sendible/localization';
import { advancedLocalStorage, isAutomationEnvironment } from '@sendible/common';
import storageUtils from './libs/utils/storage-utils.js';

export { FlexContainer, FlexItem } from '../react/Common/Grid/index.js';

window.advancedLocalStorage = advancedLocalStorage;
window.isAutomationEnvironmentCheck = isAutomationEnvironment;
window.storageUtils = storageUtils;
window.lookup = lookup;
window.moment = moment;

if (!storageUtils.getCookieOrLocalStorageItem('device_id')) {
  advancedLocalStorage.setItem(
    'device_id',
    // eslint-disable-next-line
    Math.floor(Math.random() * 99999999999999999),
    365,
  );
}

import('./appInitialise.js').then((AppInitialiseModule) => {
  // Determine if we are in concise mode.
  // The concise appRouter/chrome template will be loaded in concise mode.
  const AppInitialise = AppInitialiseModule.default;
  const isConcise = document.location.pathname.indexOf('/concise/') !== -1;

  // initialise and process the user credentials (checks if user is logged in/requesting access and routes appropriately)
  if (!isConcise) {
    AppInitialise.initialise();
  } else {
    AppInitialise.initialise({
      isConcise,
    });
  }
  // Applies fix for multiple modal dialog issue. .....
  // Amanda: Only reference of bootstrap-modal comes from classic, this needs to be added there.
  $.fn.modal.Constructor.prototype.enforceFocus = function () {};
});
